<template>
  <v-row>
    <audience-selector-element
      v-for="(path, index) in creativePaths"
      :key="index"
      :path="path"
      :active="path.value === activePath"
      @selectCreativePath="selectCreativePath"
      v-if="!path.feature || features[path.feature]"
    />
  </v-row>
</template>

<script>
import AudienceSelectorElement from './AudienceSelectorElement.vue'
export default {
    name: 'audience-path-selector',
    components: { AudienceSelectorElement },
    data () {
      return {
        creativePaths: [
          {
            icon: 'library_books',
            title: 'Select a saved audience',
            value: 'saved-audiences-table'
          },
          {
            icon: 'attachment',
            title: 'Upload a target list',
            value: 'upload-stepper'
          },
          // {
          //   icon: 'how_to_vote',
          //   title: 'Import voter list from NGP VAN',
          //   value: 'voter-list'
          // },
          {
            icon: 'people',
            title: 'Use a Facebook audience',
            value: 'fb-audience'
          },
          {
            icon: 'devices',
            title: 'Visitors to my site or my Facebook page',
            value: 'rem',
            feature: 'audiences_rem'
          },
          {
            icon: 'group_add',
            title: 'Lookalike',
            value: 'lookalike',
            feature: 'audiences_lal'
          }
        ]
      }
    },
    props: {
      activePath: {
        type: String,
        default: ''
      }
    },
    methods: {
      closeDialog () {
        this.$emit('closeDialog')
      },
      selectCreativePath (path) {
        this.$emit('selectCreativePath', path)
      }
    },
    computed: {
      features () {
        const version = this.$store.getters.getAppVersion
        return this.$store.getters.getFeatures[version]
      }
    }
  }
</script>
